var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-export-dialog', {
    attrs: {
      "query": _vm.exportQuery,
      "formValid": _vm.formValid,
      "jobType": "export",
      "format": "csv",
      "resource": "digital-twin-rule-executions"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close-export-dialog');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionHistoryExport.titleSlot')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "subtitleParagraph",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionHistoryExport.subtitleSlot')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "fields",
      fn: function () {
        return [_c('core-date-time-picker', {
          staticStyle: {
            "margin-bottom": "30px !important"
          },
          attrs: {
            "from": _vm.start / 1000,
            "to": _vm.end / 1000,
            "isRange": ""
          },
          on: {
            "date:picked": _vm.datePicked
          }
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };